<template>
  <div class="login">
    <div class="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-5 mx-auto">
      <div class="card card0 border-3" style="border-radius:10px;">
        <div class="row d-flex">
          <div class="col-lg-7">
            <div class="card1 pb-5">
              <div class="row">
                <img src="/logo.png" class="logo" />
              </div>
              <div class="row px-3 justify-content-center mt-4 mb-5">
                <img src="/nuta.png" class="image" style="padding-top:100px" />
              </div>
            </div>
          </div>
          <div class="col-lg-5 border-line">
            <form @submit.prevent="userLogin">
              <div class="card2 card border-0 px-4 py-5">
                <div class="row">
                  <div class="col-lg-12 text-center">
                      <h4><b>LOGIN</b></h4>
                  </div>
                </div>

                <div class="row py-13" style="padding-top:10%;padding-left:5%">
                  <div class="col-0" style="
                  width:25px;
                  height:25px;
                  background-color:#00ae2b;
                  color:white;
                  border-radius:100%;
                  padding-left:8px;
                  padding-top:1px;
                  ">1</div>
                  
                  <div class="col-4" style="margin:10px 3% 10px 3%;border-top: 3px solid #9b9b9b;"></div>

                  <div class="col-0" style="
                  width:25px;
                  height:25px;
                  background-color:#00ae2b;
                  color:white;
                  border-radius:100%;
                  padding-left:8px;
                  padding-top:1px;
                  ">2</div>

                  <div class="col-4" style="margin:10px 3% 10px 3%;border-top: 3px solid #9b9b9b;"></div>
                  
                  <div class="col-0" style="
                  width:25px;
                  height:25px;
                  background-color:#9b9b9b;
                  color:white;
                  border-radius:100%;
                  padding-left:8px;
                  padding-top:1px;
                  ">3</div>
                </div>

                <div class="row" style="padding-top:10%">
                  <label class="col-lg-12 text-center">
                    Silahkan isikan berikut untuk login ke kasir Nutacloud
                  </label>
                  <div class="col-lg-12">
                    <div class="form-group">
                      <label class="floating-custom">Nama User Nutacloud</label>
                      <input class=""
                      type="text" 
                      v-model="form.username"
                      name="username">
                      <i v-if="errors"><small class="text-danger">{{ errors }}</small></i>
                    </div>

                    <div class="form-group" style="margin-top:-10px">
                      <label class="floating-custom-password">Password</label>
                      <div class="input-group" id="show_hide_password">
                        <input class="form-control" style="height: 43px !important"
                        type="password" 
                        v-model="form.password"
                        name="password">
                        <a href="" class="iconhiden"><i class="fa fa-eye-slash" style="padding-top:10px !important" ></i></a> 
                      </div>
                      <i v-if="errors2"><small class="text-danger">{{ errors2 }}</small></i>
                    </div>
                  </div>
                </div>

                <div class="row mb-7" style="padding-top:10%">
                  <label class="col-2 control-label-bold col-4 text-green" style="margin-top:9px;text-align: left !important;" @click="$router.go(-1)">
                    Kembali
                  </label>
                  <button type="submit" class="col-4 btn btn-green text-center" style="border-radius:5px; margin-left:30%" :disabled="submitted">
                    <span v-html="btnLogin"></span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters,mapActions } from "vuex";
import $ from 'jquery'

export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      submitted: false,
      errors: null,
      errors2: null,
      btnLogin:"Lanjut"
    };
  },
  mounted() {
    this.getUserPerusahaan(); 
    $(document).ready(function () {
        $("#show_hide_password a").on("click", function (event) {
          event.preventDefault();
          if ($("#show_hide_password input").attr("type") == "text") {
            $("#show_hide_password input").attr("type", "password");
            $("#show_hide_password i").addClass("fa-eye-slash");
            $("#show_hide_password i").removeClass("fa-eye");
          } else if ($("#show_hide_password input").attr("type") == "password") {
            $("#show_hide_password input").attr("type", "text");
            $("#show_hide_password i").removeClass("fa-eye-slash");
            $("#show_hide_password i").addClass("fa-eye");
          }
        });
      });

  },
  methods: {
    ...mapActions(["loginUser"]),
    getUserPerusahaan(){
        if (this.username !=null){
            this.form.username = this.username
            this.form.password = this.password 
        }
    },
    userLogin() {
      this.submitted = true;
      this.btnLogin = "<div class='fa fa-circle-notch fa-spin'></div>";
      this.$store
        .dispatch("loginUser", this.form)
        .then((response) => {
          if (response.status == "OK") {
            this.submitted = false;
            this.$router.push({name: 'Pilih Outlet'})
          } else {
            if(this.form.username==""){
                this.errors = "Nama user nutacloud tidak boleh kosong";
                this.errors2 ="";
                this.submitted = false;
            }
            else if(this.form.password==""){
                this.errors2 = "Password tidak boleh kosong";
                this.errors ="";
                this.submitted = false;
            }
            else{
               if (response.message[0]=="Password yang anda masukkan salah"){
                  this.errors2 = response.message[0];
                  this.errors ="";
                  this.submitted = false;
               }
               else{
                  this.errors = response.message[0];
                  this.errors2 ="";
                  this.submitted = false;
               }
            }
          }
          this.btnLogin = "Lanjut";
        })
        .catch((error) => {
          this.errors = error.statusText;
          this.submitted = false;
          this.btnLogin = "Lanjut";
        });
    },
  },
  computed: {
    ...mapGetters(["username","password"]),
  }
};
</script>
<style scoped>
body {
  color: #000;
  overflow-x: hidden;
  height: 100%;
  background-repeat: no-repeat;
}

.card0 {
  box-shadow: 0px 3px 8px 0px #757575;
  border-radius: 0px;
}

.card2 {
  margin: 0px 40px;
}

.logo {
  width: 150px;
  height:30px;
  transform: translateX(30px) translateY(21px);
}

.image {
  width: 650px;
  height: auto;
}

.border-line {
  border-left: 1px solid #eeeeee;
  margin-top:10px;
  margin-bottom:10px;
}

.or {
  width: 10%;
  font-weight: bold;
}

input,
textarea {
  padding: 10px 12px 10px 12px;
  border: 1px solid rgb(148, 148, 148);
  border-radius: 2px;
  margin-bottom: 5px;
  margin-top: 2px;
  width: 100%;
  box-sizing: border-box;
  color: #000000;
  font-size: 14px;
  letter-spacing: 1px;
}

input:focus,
textarea:focus {
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: 1px solid #00ae2b;
  outline-width: 0;
}


button:focus {
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline-width: 0;
}

a {
  color: inherit;
  cursor: pointer;
}

.btn-green {
  background-color: #00ae2b;
  width: 150px;
  color: #fff;
  border-radius: 2px;
}

.btn-green:hover {
  background-color: #019b28;
  cursor: pointer;
}
.floating-custom {
    font-size: 14px;
    transform: translateY(95%) translateX(10%);
    background:#fff;
}
.floating-custom-password {
    font-size: 14px;
    transform: translateY(60%) translateX(10%);
    background:#fff;
    z-index: 1;
}
.iconhiden{
    position: absolute;
    right: 4px;
    width:30px;
    z-index: 10;
    top:6px;
    height:35px; 
}
@media screen and (max-width: 991px) {
  .logo {
    margin-left: 0px;
  }

  .image {
    width: 300px;
    height: 220px;
  }

  .border-line {
    border-right: none;
  }

  .card2 {
    border-top: 1px solid #eeeeee !important;
    margin: 0px 15px;
  }
}
</style>